<template>
	<div class="info">
		<div class="info_title">{{$tt('押解组A：张三(负责人)')}}
			<svg class="icon" aria-hidden="true" style="width: 20px;height: 20px;margin-left: 50%; vertical-align:middle;"
			 @click="closeGroupInfo">
				<use xlink:href="#icon-guanbi" fill="#ffffff"></use>
			</svg>&nbsp;&nbsp;
		</div>
		<div class="info_tab">
			<Row>
				<Col span="8">
				<svg class="icon" aria-hidden="true" style="width: 34px;height: 34px; vertical-align:middle;" @click="select(1)">
					<use xlink:href="#icon-tubiao" :class="selectTab==1?'fillColor':''" fill="#217ECD"></use>
				</svg>
				</Col>
				<Col span="8">
				<svg class="icon" aria-hidden="true" style="width: 34px;height: 34px; vertical-align:middle;" @click="select(2)">
					<use xlink:href="#icon-gaojing" :class="selectTab==2?'fillColor':''" fill="#217ECD"></use>
				</svg>
				</Col>
				<Col span="8">
				<svg class="icon" aria-hidden="true" style="width: 34px;height: 34px; vertical-align:middle;" @click="select(3)">
					<use xlink:href="#icon-icon_weizhidingwei" :class="selectTab==3?'fillColor':''" fill="#217ECD"></use>
				</svg>
				</Col>
			</Row>

		</div>

		<div class="info_group">
			<!--个人信息-->
			<span v-if="selectTab==1">
				<Row>
					<Col span="24">
					<img src="../../../assets/online.png" width="50px" height="50px" style="border-radius: 25px;" />
					</Col>
				</Row>

				<Row>
					<Col span="12" style="text-align: left;">
					<Tag color="default">{{$tt('姓名：张三')}}</Tag>
					<Tag color="default">{{$tt('性别：男')}}</Tag>
					<Tag color="default">{{$tt('出生年月：1997-02-14')}}</Tag>

					</Col>

					<Col span="12" style="text-align: left;">
					<Tag color="default">{{$tt('状态：正在监控')}}</Tag>
					<Tag color="default">{{$tt('身高：170cm')}}</Tag>
					<Tag color="default">{{$tt('绰号：老大')}}</Tag>

					</Col>
				</Row>

				<Row>
					<Col span="24" style="text-align: left;">
					<Tag color="default">{{$tt('涉案说明：家庭纠纷')}}</Tag>
					<Tag color="default">{{$tt('绑定设备：908043179698')}}</Tag>
					</Col>
				</Row>
			</span>

			<!--警情列表-->
			<span v-if="selectTab==2">
				<Card style="width:98%;background-color: #23223F;margin: 0 auto;color: #767676;">
					<div style="text-align:left;">
						<img src="../../../assets/bug.png" align="left" style="margin-right: 20px;" />
						<p align="left">{{$tt('老邓 hyG 90803685')}}</p>
						<p align="left">{{$tt('超警戒距离')}}</p>
						<p align="left">{{$tt('时间：2020-9-18 11:00:00')}}</p>
					</div>
				</Card>
				<Card style="width:98%;background-color: #23223F;margin: 0 auto;color: #767676;">
					<div style="text-align:left;">
						<img src="../../../assets/bug.png" align="left" style="margin-right: 20px;" />
						<p align="left">{{$tt('老邓 hyG 90803685')}}</p>
						<p align="left">{{$tt('超警戒距离')}}</p>
						<p align="left">{{$tt('时间：2020-9-18 11:00:00')}}</p>
					</div>
				</Card>
				<Card style="width:98%;background-color: #23223F;margin: 0 auto;color: #767676;">
					<div style="text-align:left;">
						<img src="../../../assets/bug.png" align="left" style="margin-right: 20px;" />
						<p align="left">{{$tt('老邓 hyG 90803685')}}</p>
						<p align="left">{{$tt('超警戒距离')}}</p>
						<p align="left">{{$tt('时间：2020-9-18 11:00:00')}}</p>
					</div>
				</Card>
			</span>
			<!--轨迹回放-->
			<span v-if="selectTab==3">
				<Row>
					<Col span="24" style="text-align: center;height: 20px;color: white;margin-top: 40px;">
					
						{{$tt('起止时间：')}}<DatePicker type="datetimerange" format="yyyy-MM-dd HH:mm" :placeholder="$tt('请输入起止时间')" ></DatePicker>
					
					</Col>
				</Row>
				
				<Row style="margin-top: 30px;">
					<Col span="8" style="">
					
						<svg class="icon" aria-hidden="true" style="width: 34px;height: 34px; vertical-align:middle;" @click="back()">
							<use xlink:href="#icon-kuaitui" :class="select" fill="#217ECD"></use>
						</svg>
					
					</Col>
					<Col span="8" style="">
					<span v-if="play">
						<svg class="icon" aria-hidden="true" style="width: 34px;height: 34px; vertical-align:middle;" @click="startAndSuspend()">
							<use xlink:href="#icon-bofang_huaban" :class="select" fill="#217ECD"></use>
						</svg>
					</span>
					
					<span v-else>
						<svg class="icon" aria-hidden="true" style="width: 34px;height: 34px; vertical-align:middle;" @click="startAndSuspend()">
							<use xlink:href="#icon-bofang" :class="select" fill="#217ECD"></use>
						</svg>
					</span>
					</Col>
					<Col span="8" style="">
					
						<svg class="icon" aria-hidden="true" style="width: 34px;height: 34px; vertical-align:middle;" @click="forward()">
							<use xlink:href="#icon-kuaijin" :class="select" fill="#217ECD"></use>
						</svg>
					
					</Col>
				</Row>
				
				<Row style="margin-top: 30px;">
					<Col span="24" style="">
					<Tag color="default">{{$tt('当前播放速度：X')}} {{speed}}</Tag>
					
					</Col>
				</Row>
			</span>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectTab: 1,//tab选择
				speed:1,//播放速度
				play:true
			}
		},

		mounted() {

		},
		methods: {
			closeGroupInfo: function() {
				this.$emit("closeGroupInfo")
			},
			select: function(id) {
				this.selectTab = id;
				//document.getElementsByClassName("icon").
			},
			//快进
			forward:function(){
				if(this.speed!=16)
				this.speed=this.speed*2;
				else  this.$Message.error(this.$tt('最大16'));
			},
			//快退
			back:function(){
				if(this.speed!=1)
				this.speed=this.speed/2;
				else
				this.$Message.error({
                content: 'll be gone in 10 seconds',
                duration: 100
            });
			},
			//暂停&开始
			startAndSuspend:function(){
				this.play=!this.play
			}

		}
	}
</script>

<style>
	.info {
		height: 100%;
		width: 16%;
		position: absolute;
		z-index: 1;
		/* background-color: black; */

		margin-left: 12.1%;

		background-color: #191730;
		 cursor:pointer;
		 
	}

	.info_title {
		width: 100%;
		height: 30px;
		border-bottom: 1px solid #217ECD;
		text-align: left;
		color: #65CE90;
		line-height: 30px;
	}

	.info_tab {
		width: 100%;
		height: 60px;
		border-bottom: 1px solid #217ECD;
		line-height: 60px;
		margin-bottom: 10px;
	}

	.info_group {
		width: 95%;
		margin: 0 auto;
		color: white;
	}

	.fillColor {
		fill: red;
		background-color: #000000;
	}
.select:active{
	fill: red;
}
	/**
	 * iview card
	 */
	.ivu-card:hover {
		border: 1px solid #484848;
	}
	
	
	.ivu-tag-text{
		color: white;
	}
</style>
